import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 160,
	viewBox: "0 0 201 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 32C24.8367 32 32 24.8365 32 16C32 7.16347 24.8367 0 16 0C7.16333 0 0 7.16347 0 16C0 24.8365 7.16333 32 16 32ZM28.14 10.4749C27.2893 9.00293 23.8867 9.26967 19.6747 10.8999C17.904 8.63607 14.7007 7.9562 12.152 9.4254C9.60333 10.8949 8.59134 14.0057 9.67 16.6689C6.14934 19.4979 4.216 22.3089 5.06667 23.7811C6.25067 25.8293 12.3753 24.511 18.7473 20.8366C25.1187 17.1621 29.324 12.5231 28.14 10.4749Z",
			fillRule: "evenodd",
			clipRule: "evenodd",
			fill: "#3FCE71"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.293 27.5379V8.41698H181.567V4.46094H199.37V8.41698H192.644V27.5379H188.293Z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke0_344_521",
			maskUnits: "userSpaceOnUse",
			x: 180.567,
			y: 3.46094,
			width: 20,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 180.567,
				y: 3.46094,
				width: 20,
				height: 26
			}), /* @__PURE__ */ _jsx("path", { d: "M188.293 27.5379V8.41698H181.567V4.46094H199.37V8.41698H192.644V27.5379H188.293Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.293 27.5379V8.41698H181.567V4.46094H199.37V8.41698H192.644V27.5379H188.293Z",
			strokeWidth: 2,
			mask: "url(#stroke0_344_521)"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#stroke1_344_521",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke2_344_521",
			maskUnits: "userSpaceOnUse",
			x: 160.52,
			y: 3.46094,
			width: 20,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 160.52,
				y: 3.46094,
				width: 20,
				height: 26
			}), /* @__PURE__ */ _jsx("use", { xlinkHref: "#stroke1_344_521" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.52 27.5379V4.46094H171.542C172.992 4.46094 174.256 4.71368 175.333 5.21918C176.41 5.72467 177.245 6.43896 177.838 7.36204C178.432 8.28511 178.728 9.37303 178.728 10.6258V11.0214C178.728 12.406 178.399 13.5269 177.739 14.384C177.08 15.2412 176.267 15.8675 175.3 16.2631V16.8565C176.179 16.9005 176.86 17.2082 177.344 17.7796C177.827 18.3291 178.069 19.0653 178.069 19.9884V27.5379H173.717V20.6148C173.717 20.0873 173.574 19.6587 173.289 19.3291C173.025 18.9994 172.574 18.8346 171.937 18.8346H165.871V27.5379H161.52ZM165.871 14.8785H171.08C172.113 14.8785 172.915 14.6038 173.487 14.0543C174.08 13.4829 174.377 12.7357 174.377 11.8126V11.4829C174.377 10.5598 174.091 9.82357 173.52 9.27412C172.948 8.7027 172.135 8.41698 171.08 8.41698H165.871V14.8785Z",
			strokeWidth: 2,
			mask: "url(#stroke2_344_521)"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#stroke3_344_521",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke4_344_521",
			maskUnits: "userSpaceOnUse",
			x: 136.725,
			y: 3,
			width: 21,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 136.725,
				y: 3,
				width: 21,
				height: 26
			}), /* @__PURE__ */ _jsx("use", { xlinkHref: "#stroke3_344_521" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.219 28C144.318 28 142.01 27.2088 140.296 25.6264C138.582 24.022 137.725 21.7363 137.725 18.7692V13.2308C137.725 10.2637 138.582 7.98901 140.296 6.40659C142.01 4.8022 144.318 4 147.219 4C150.12 4 152.428 4.8022 154.142 6.40659C155.856 7.98901 156.714 10.2637 156.714 13.2308V18.7692C156.714 21.7363 155.856 24.022 154.142 25.6264C152.428 27.2088 150.12 28 147.219 28ZM147.219 24.1099C148.845 24.1099 150.109 23.6374 151.01 22.6923C151.911 21.7473 152.362 20.4835 152.362 18.9011V13.0989C152.362 11.5165 151.911 10.2527 151.01 9.30769C150.109 8.36264 148.845 7.89011 147.219 7.89011C145.615 7.89011 144.351 8.36264 143.428 9.30769C142.527 10.2527 142.076 11.5165 142.076 13.0989V18.9011C142.076 20.4835 142.527 21.7473 143.428 22.6923C144.351 23.6374 145.615 24.1099 147.219 24.1099Z",
			strokeWidth: 2,
			mask: "url(#stroke4_344_521)"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#stroke5_344_521",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke6_344_521",
			maskUnits: "userSpaceOnUse",
			x: 116.366,
			y: 3.46094,
			width: 19,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 116.366,
				y: 3.46094,
				width: 19,
				height: 26
			}), /* @__PURE__ */ _jsx("use", { xlinkHref: "#stroke5_344_521" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.366 27.5379V4.46094H126.861C128.311 4.46094 129.586 4.75764 130.685 5.35105C131.806 5.92248 132.674 6.73566 133.289 7.79061C133.927 8.84555 134.245 10.0983 134.245 11.5489V12.0104C134.245 13.439 133.916 14.6917 133.256 15.7686C132.619 16.8236 131.74 17.6478 130.619 18.2412C129.52 18.8126 128.267 19.0983 126.861 19.0983H121.718V27.5379H117.366ZM121.718 15.1423H126.432C127.465 15.1423 128.3 14.8565 128.938 14.2851C129.575 13.7137 129.894 12.9335 129.894 11.9445V11.6148C129.894 10.6258 129.575 9.84555 128.938 9.27412C128.3 8.7027 127.465 8.41698 126.432 8.41698H121.718V15.1423Z",
			strokeWidth: 2,
			mask: "url(#stroke6_344_521)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.123 27.5379V4.46094H112.958V8.41698H102.475V13.9225H112.035V17.8785H102.475V23.5818H113.156V27.5379H98.123Z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke7_344_521",
			maskUnits: "userSpaceOnUse",
			x: 97.123,
			y: 3.46094,
			width: 18,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 97.123,
				y: 3.46094,
				width: 18,
				height: 26
			}), /* @__PURE__ */ _jsx("path", { d: "M98.123 27.5379V4.46094H112.958V8.41698H102.475V13.9225H112.035V17.8785H102.475V23.5818H113.156V27.5379H98.123Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.123 27.5379V4.46094H112.958V8.41698H102.475V13.9225H112.035V17.8785H102.475V23.5818H113.156V27.5379H98.123Z",
			strokeWidth: 2,
			mask: "url(#stroke7_344_521)"
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#stroke8_344_521",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke9_344_521",
			maskUnits: "userSpaceOnUse",
			x: 75.3047,
			y: 3.46094,
			width: 20,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 75.3047,
				y: 3.46094,
				width: 20,
				height: 26
			}), /* @__PURE__ */ _jsx("use", { xlinkHref: "#stroke8_344_521" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.3047 27.5379V4.46094H86.3267C87.7772 4.46094 89.041 4.71368 90.1179 5.21918C91.1948 5.72467 92.03 6.43896 92.6234 7.36204C93.2168 8.28511 93.5135 9.37303 93.5135 10.6258V11.0214C93.5135 12.406 93.1838 13.5269 92.5245 14.384C91.8651 15.2412 91.0519 15.8675 90.0849 16.2631V16.8565C90.964 16.9005 91.6453 17.2082 92.1289 17.7796C92.6124 18.3291 92.8541 19.0653 92.8541 19.9884V27.5379H88.5025V20.6148C88.5025 20.0873 88.3596 19.6587 88.0739 19.3291C87.8102 18.9994 87.3596 18.8346 86.7223 18.8346H80.6563V27.5379H76.3047ZM80.6563 14.8785H85.8651C86.8981 14.8785 87.7003 14.6038 88.2717 14.0543C88.8651 13.4829 89.1618 12.7357 89.1618 11.8126V11.4829C89.1618 10.5598 88.8761 9.82357 88.3047 9.27412C87.7333 8.7027 86.9201 8.41698 85.8651 8.41698H80.6563V14.8785Z",
			strokeWidth: 2,
			mask: "url(#stroke9_344_521)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.123 3.96094H71.4747V28.0379H66.123V3.96094Z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 27.5379V4.46094H48.3516V13.9884H56.9231V4.46094H61.2747V27.5379H56.9231V17.9445H48.3516V27.5379H44Z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "stroke10_344_521",
			maskUnits: "userSpaceOnUse",
			x: 43,
			y: 3.46094,
			width: 20,
			height: 26,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 43,
				y: 3.46094,
				width: 20,
				height: 26
			}), /* @__PURE__ */ _jsx("path", { d: "M44 27.5379V4.46094H48.3516V13.9884H56.9231V4.46094H61.2747V27.5379H56.9231V17.9445H48.3516V27.5379H44Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 27.5379V4.46094H48.3516V13.9884H56.9231V4.46094H61.2747V27.5379H56.9231V17.9445H48.3516V27.5379H44Z",
			strokeWidth: 2,
			mask: "url(#stroke10_344_521)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "stroke1_344_521",
				d: "M161.52 27.5379V4.46094H171.542C172.992 4.46094 174.256 4.71368 175.333 5.21918C176.41 5.72467 177.245 6.43896 177.838 7.36204C178.432 8.28511 178.728 9.37302 178.728 10.6258V11.0214C178.728 12.406 178.399 13.5269 177.739 14.384C177.08 15.2412 176.267 15.8675 175.3 16.2631V16.8565C176.179 16.9005 176.86 17.2082 177.344 17.7796C177.827 18.3291 178.069 19.0653 178.069 19.9884V27.5379H173.717V20.6148C173.717 20.0873 173.574 19.6587 173.289 19.3291C173.025 18.9994 172.574 18.8346 171.937 18.8346H165.871V27.5379H161.52ZM165.871 14.8785H171.08C172.113 14.8785 172.915 14.6038 173.487 14.0543C174.08 13.4829 174.377 12.7357 174.377 11.8126V11.4829C174.377 10.5598 174.091 9.82357 173.52 9.27412C172.948 8.7027 172.135 8.41698 171.08 8.41698H165.871V14.8785Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "stroke3_344_521",
				d: "M147.219 28C144.318 28 142.01 27.2088 140.296 25.6264C138.582 24.022 137.725 21.7363 137.725 18.7692V13.2308C137.725 10.2637 138.582 7.98901 140.296 6.40659C142.01 4.8022 144.318 4 147.219 4C150.12 4 152.428 4.8022 154.142 6.40659C155.856 7.98901 156.714 10.2637 156.714 13.2308V18.7692C156.714 21.7363 155.856 24.022 154.142 25.6264C152.428 27.2088 150.12 28 147.219 28ZM147.219 24.1099C148.845 24.1099 150.109 23.6374 151.01 22.6923C151.911 21.7473 152.362 20.4835 152.362 18.9011V13.0989C152.362 11.5165 151.911 10.2527 151.01 9.30769C150.109 8.36264 148.845 7.89011 147.219 7.89011C145.615 7.89011 144.351 8.36264 143.428 9.30769C142.527 10.2527 142.076 11.5165 142.076 13.0989V18.9011C142.076 20.4835 142.527 21.7473 143.428 22.6923C144.351 23.6374 145.615 24.1099 147.219 24.1099Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "stroke5_344_521",
				d: "M117.366 27.5379V4.46094H126.861C128.311 4.46094 129.586 4.75764 130.685 5.35105C131.806 5.92248 132.674 6.73566 133.289 7.79061C133.927 8.84555 134.245 10.0983 134.245 11.5489V12.0104C134.245 13.439 133.916 14.6917 133.256 15.7686C132.619 16.8236 131.74 17.6477 130.619 18.2412C129.52 18.8126 128.267 19.0983 126.861 19.0983H121.718V27.5379H117.366ZM121.718 15.1423H126.432C127.465 15.1423 128.3 14.8565 128.938 14.2851C129.575 13.7137 129.894 12.9335 129.894 11.9445V11.6148C129.894 10.6258 129.575 9.84555 128.938 9.27412C128.3 8.7027 127.465 8.41698 126.432 8.41698H121.718V15.1423Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "stroke8_344_521",
				d: "M76.3047 27.5379V4.46094H86.3267C87.7772 4.46094 89.041 4.71368 90.1179 5.21918C91.1948 5.72467 92.03 6.43896 92.6234 7.36204C93.2168 8.28511 93.5135 9.37302 93.5135 10.6258V11.0214C93.5135 12.406 93.1838 13.5269 92.5245 14.384C91.8651 15.2412 91.0519 15.8675 90.0849 16.2631V16.8565C90.964 16.9005 91.6453 17.2082 92.1289 17.7796C92.6124 18.3291 92.8541 19.0653 92.8541 19.9884V27.5379H88.5025V20.6148C88.5025 20.0873 88.3596 19.6587 88.0739 19.3291C87.8102 18.9994 87.3596 18.8346 86.7223 18.8346H80.6563V27.5379H76.3047ZM80.6563 14.8785H85.8651C86.8981 14.8785 87.7003 14.6038 88.2717 14.0543C88.8651 13.4829 89.1618 12.7357 89.1618 11.8126V11.4829C89.1618 10.5598 88.8761 9.82357 88.3047 9.27412C87.7333 8.7027 86.9201 8.41698 85.8651 8.41698H80.6563V14.8785Z"
			})
		] })
	]
});
export default SvgLogo;
